import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
    CITy,
    ContactMechanisms,
    GEOGRAPHICAL_REGIONS,
    Grade,
    POSTAL_ADDRESSES,
    POSTAL_CODE,
    School,
    SCHOOL_PROPERTY_TYPE,
    SCHOOL_STATUS,
    SCHOOL_TYPE,
    STATE
} from 'src/app/model/school.model'; // PartyContactMechanisms,
import { PostalCode as PostalCode2 } from 'src/app/component/common-components/location/model/postal-code.model';
import { Component, Inject, OnInit, OnDestroy, ElementRef, ViewChild, EventEmitter, Output, AfterViewInit, Input, ChangeDetectorRef, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';

import { PARTYROLE, Region } from 'src/app/model/region.model';
import { County } from '../../../model/county';
import { AppState } from 'src/app/reducers';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { DistrictEntityService } from 'src/app/component/common-components/service/district-entity.service';
import { CountyEntityService } from 'src/app/component/common-components/service/county-entity.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { User } from '../../auth/model/user.model';
import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { OrganizationService } from '../../common-components/organizations/service/organization.service';
import { Observable, Subject } from 'rxjs'; // filter, debounceTime, map, Subscription, takeUntil
import Swal from 'sweetalert2';
import { HelperService } from 'src/app/service/helper.service';
import { Store } from '@ngrx/store';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';
import { PartyRoleTypes } from 'src/app/component/party/model/party-role-types.model';
import { RegionEntityService } from '../../common-components/service/region-entity.service';
import { MatCalendar } from '@angular/material/datepicker';
import { CustomDatepickerComponent } from '../../common-components/custom-datepicker/custom-datepicker.component';
import { UtilityService } from 'src/app/service/utility.service';
import { ContactPerson } from '../../party/model/contact-person.model';
import { City } from '../../common-components/location/model/city.model';
import { Country } from '../../common-components/location/model/country.model';
import { ContactMechanismsService } from '../../party/service/contact-mechanisms.service';
import { PartyRolesService } from '../../party/service/party-roles.service';

import { State } from '../../common-components/location/model/state.model';
import { InputEmailStandaloneComponent } from '../input-email-standalone/input-email-standalone.component';
import { InputEmailStandaloneService } from '../input-email-standalone/service/input-email-standalone.service';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';
import { DistrictDropdownTwoWayComponent } from '../../common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@Component({
    selector: 'app-create-school',
    templateUrl: './create-school.component.html',
    styleUrls: ['./create-school.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class CreateSchoolComponent implements OnInit, AfterViewInit, OnDestroy, ErrorStateMatcher, OnChanges {
	@ViewChild('child') child!: DistrictDropdownTwoWayComponent;
	@ViewChild('child2') child2!: RegionDropdownTwoWayComponent;
	@ViewChild('child3') child3!: CountyDropdownTwoWayComponent;
    @ViewChild('ssid') fieldSSID!: ElementRef;
    @ViewChild('emailChild') emailChild!: InputEmailStandaloneComponent;
    /*@ViewChild('childCity') childCity!: InputCityAutocompleteComponent;
    @ViewChild('childState') childState!: InputStateAutocompleteComponent;
    @ViewChild('childZip') childZip!: InputZipcodeAutocompleteComponent;
    @ViewChild('childLowGrade') childLowGrade!: Selection;
    @ViewChild('childHighGrade') childHighGrade!: Selection;
    */

    @ViewChild('tabGroup') tabGroup: any;
    @ViewChild('calendar') calendar: MatCalendar<Moment>;
    @Input() isCreated: boolean = false; 
    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();

    @Output() btnClick = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() btnClick2 = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() createdStatusChanged = new EventEmitter<boolean>(); 

    selected = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    selectedTab = new UntypedFormControl(0);
    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);

    schoolNameFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    schoolDistrictNcesFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(7)])); //
    chkSatelliteCampusFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    selectLowGradeFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    selectHighGradeFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    radioSchoolTypeFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    radioSchoolStatusFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    txtSchoolCodeFC = new UntypedFormControl('', Validators.compose([Validators.required])); //
    txtSchoolNcesFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])); //
    txtStreet1FC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtStreet2FC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtCityFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtStateFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtZipcodeFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //

    txtFirstNameFC = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtLastNameFC = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtPhoneNumberFC = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtEmailFC = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    emailObj: string = 'txtEmailFC';
    isInitialLoad: boolean = true;
    defaultRegionAsBlank: boolean = true;
    resetSchoolCode: string = '';
    bCustomSchoolCodeError: boolean = false;
    strCustomSchoolCodeError: string = '';

    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';

    customLabelRegion: string = "School's Region *";
    customLabelCounty: string = "School's County *";
    customLabelDistrict: string = "School's District *";

    region!: Region;
    regionCap!: Region;
    district!: SchoolDistrict;

    districts = [];
    resetField: boolean = false;
    selectedCounty: number | ''; //undefined;
    myCounty: County;
    myCounties: County[] = [];
    newNumArray: number[] = [];
    myRegions: Region;
    selectedSchoolDistrict: number = 0;
    selectedDistrict: number | ''; // undefined;
    schoolDistricts: SchoolDistrict[] = [];
    allSchoolDistricts: SchoolDistrict[] = [];
    allSchoolCounties: County[] = [];
    allSchoolRegions: Region[] = [];
    schoolRegionIds: number[] = [];
    schoolDistrictIds: number[] = [];
    selectedSchoolDistrictIds: number[] = [];
    selectedSchoolDistrictName: string | ''; //undefined;

	chosenRegions: Region[] = [];
	chosenCounties: County[] = [];
	chosenSchoolDistricts: SchoolDistrict[] = [];

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
    selectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);

    matcher = this;
    serializedDate: any;
    newTestDateFC: UntypedFormControl;
    cleanedCreatedDate: UntypedFormControl;
    events: string[] = []; // this is for date events
    selectedDate: Moment;
    isUneditable: boolean = true;
    createBtnText: string = 'Create';
    bCancelCreate: boolean = false;

    schoolID: number = 0;
    schoolTypeID: number = 0;
    schoolPropertyTypesID: number = 0;
    schoolPropertyID: number = 2; // 2 is default here
    schoolStatusId: number = 1;
    thisSchoolStatus: number = 1;
    CDSCode: string = '';
    closedDate?: string = '';
    gradeSpanHigh: number = 0;
    gradeSpanLow: number = 0;
    gradesTable: number[];
    gradeItems: Grade[];

    subTypeItems: SCHOOL_TYPE[] = [];
    bDisAllowSubTypes: boolean = true;
    bAllowSC: boolean = false;
    selectedSubTypeItem: number = 0;

    iToggleSCValid1: number = 0;
    iToggleSCValid2: number = 0;
    iToggleSCValid3: number = 0;
    bCheckedSCCode1: boolean = false;
    bCheckedSCCode2: boolean = false;
    bCheckedSCCode3: boolean = false;

    radioOptionsSchoolType: any = [
        {
            id: 1,
            name: 'Public',
            checked: false,
            fnToCall: 'fnTogglePublicOrPrivateSubTypes()'
        },
        {
            id: 2,
            name: 'Private',
            checked: false,
            fnToCall: 'fnTogglePublicOrPrivateSubTypes()'
        },
        {
            id: 3,
            name: 'Other',
            checked: false,
            fnToCall: 'fnToggleSubTypes()'
        }
    ];

    radioOptionsSchoolStatus: any = [
        {
            id: 1,
            name: 'Open',
            checked: false,
            fnToCall: 'fnToggleOpenOrClosedStatus()'
        },
        {
            id: 2,
            name: 'Closed / Merged',
            checked: false,
            fnToCall: 'fnToggleOpenOrClosedStatus()'
        }
    ];

    bDisableCreateButton: boolean = false;
    schoolNCES: string = '';
    selectedNcesCode: string = '';
    schoolDistrictNCES: string = '';
    txtStreet1: string = '';
    txtStreet2: string = '';
    txtCity: string = '';
    objCity: City = new City();
    txtState: string = '';
    objState: State = new State();
    objCountry: Country = new Country();
    txtZipcode: string = '';
    objZipcode: PostalCode2 = new PostalCode2();
    txtFirstName: string = '';
    txtLastName: string = '';
    txtPhoneNumber: string = '';
    txtEmail: string = '';
    schoolName: string = '';
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];

    type: string = 'Organization'; // Organization
    partyRoleTypeSet: PartyRoleTypes[] = [];
    partyRoleType1: PartyRoleTypes;
    partyContactMechanisms: PartyContactMechanisms[] = [];
    isEditingPartyContactMechanisms: Event; //boolean = false;

    suffixes: string[] = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'VI'];

    isLoading: boolean = false;
    loadingCounter: number = 0;
    isDone: boolean = false;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};

    // init checks
    validGrades: boolean = false;
    scValid: boolean = true; // not valid would include blank or invalid
    ngChecking: boolean = false;
    ngChecked: boolean = false;
    ngValid: boolean = false;
    ncesValid: boolean = true;
    ncesChecking: boolean = false;
    ncesChecked: boolean = false;
    cityValid: boolean = true;
    citySubmitted: boolean = false;
    cityChecking: boolean = false;
    zipValid: boolean = true;
    zipSubmitted: boolean = false;
    zipChecking: boolean = false;

    // auth
    canEditSchoolNCES: boolean = false;
    promises: Array<any> = [];

    myControl: any;
    filteredOptions!: Observable<any>;
    private unsubUsername$: Subject<void> = new Subject<void>();
    myError: string = '';
    myGradeError: string = '';
    myCloseDateError: string = '';
    createSchoolsForm!: UntypedFormGroup;
    organizationService!: OrganizationService;
    school: School;
    schoolBackup: School;
    myCity: CITy;
    myState: STATE;
    myPostalAddress: POSTAL_ADDRESSES;
    contactPerson: ContactPerson;
    schoolAddress: POSTAL_ADDRESSES;
    schoolCode: string;
    schoolStatus: number = 1;
    satelliteCampus: boolean = false;
    myPropType: SCHOOL_PROPERTY_TYPE;
    mySchoolStatus: SCHOOL_STATUS;
    schoolType: number = 1;
    partyId: any = [{}];
    organizationId!: number;
    partyIdNum!: number;
    loadedDistricts$: Observable<boolean>;
    loadedCounties$: Observable<boolean>;

    // dialog to parent components
    isOverflowEnabled: boolean;

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<CreateSchoolComponent>,
        @Inject(MAT_DIALOG_DATA) public editData: any,
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private schoolAPIService: ApiSchoolsService,
        private _organizationService: OrganizationService,
        private schoolDistrictService: DistrictEntityService,
        private schoolCountyService: CountyEntityService,
        private schoolRegionService: RegionEntityService,
        private store: Store<AppState>,
        private router: Router,
        private helperService: HelperService,
        private utilityService: UtilityService,
        private contactMechanismsService: ContactMechanismsService,
        private partyRoleService: PartyRolesService,
        private inputEmailStandaloneService: InputEmailStandaloneService,
        private cdr: ChangeDetectorRef
    ) {
        this.organizationService = _organizationService;

        this.customInit();

        this.schoolID = 0;
        this.isLoading = true;
        this.loadingCounter = this.loadingCounter + 1;
        this.loadedDistricts$ = schoolDistrictService.loaded$;
        this.loadedCounties$ = schoolCountyService.loaded$;
        this.subscribers();
        this.fnCreate();
        this.isLoading = false;
        
        this.emailChild = new InputEmailStandaloneComponent(inputEmailStandaloneService, utilityService);
        this.isOverflowEnabled = this.editData?.isOverflowEnabled ?? false;
       
    }

    ngOnChanges(changes: SimpleChanges)
    {
       if (changes['isCreated'])
        {
            console.log("toggling recognize ngOnChanges for isCreated")
            this.toggleOverflow();
        } 
    }

    ngAfterViewChecked()
    {
        this.cdr.detectChanges();  // Manually trigger change detection
        if (this.editData.isOverflowEnabled) {
            console.log("toggling recognize ngAfterViewChecked")
          this.toggleOverflow();  // Trigger the toggle when the div is shown
        }
    }

    toggleOverflow()
    {
        if (this.editData.toggleOverflow)
        {
            console.log("toggling overflow in createschool");
            this.editData.toggleOverflow();
        }
    }

    customInit(): void {


        this.createSchoolsForm = this.fb.group({
            schoolDistrictNcesFC: new UntypedFormControl(null),
            schoolNameFC: ['', [Validators.required]],
            txtSchoolNcesFC: ['', null],
            radioSchoolType: ['', [Validators.required]],
            radioSchoolStatus: ['', [Validators.required]], //new FormControl(null),
            frmCloseDate: new UntypedFormControl(null),
            selectSubType: new UntypedFormControl(null),
            selectLowGrade: ['valid', [Validators.required, Validators.pattern('valid')]], // ['', [Validators.required]], 'valid', [Validators.required, Validators.pattern('valid')]
            selectHighGrade: ['valid', [Validators.required, Validators.pattern('valid')]],
            txtSchoolCodeFC: new UntypedFormControl(null),

            txtStreet1FC: new UntypedFormControl(null),
            txtStreet2FC: new UntypedFormControl(null),
            txtCityFC: new UntypedFormControl(null),
            txtStateFC: new UntypedFormControl(null),
            txtZipcodeFC: new UntypedFormControl(null),
            txtFirstNameFC: new UntypedFormControl(null),
            txtLastNameFC: new UntypedFormControl(null),
            txtPhoneNumberFC: new UntypedFormControl(null),
            txtEmailFC: new UntypedFormControl(null),
            chkSatelliteCampus: new UntypedFormControl(null)
            // txtDistrictNCES: new FormControl(null),
            //,
            //txtSchoolDistrictNCES: new FormControl(null),
            // });
        });

        if (!this.isCreated)
        {
            this.createSchoolsForm.removeControl('selectSubType');    
            this.editData.isCreated = this.isCreated;       
        }
        else
        {
            this.createSchoolsForm.addControl('selectSubType', new UntypedFormControl(null));
            this.editData.isCreated = this.isCreated;  
        }
        this.resetField = false;
        this.isInitialLoad = true;
        this.schoolID = 0;
        this.createdStatusChanged.emit(this.isCreated);
    }

    fnCreateAnother() {
        this.myError = '';
        this.isInitialLoad = true;
        this.loadingCounter = 0;
        this.createBtnText = 'Creating...';

        this.customInit();
        this.fnResetForCreateAnother();
        setTimeout(() => {
            this.isCreated = false;
        }, 500);
    }

    fnParseCDSCode(partNum: number, inCDSCode: string): string {
        let strRet: string = '';
        switch (partNum) {
            case 1:
                try {
                    strRet = inCDSCode.substring(0, 2);
                } catch (Err) {}
                break;
            case 2:
                try {
                    strRet = inCDSCode.substring(2, 7);
                } catch (Err) {}
                break;
            case 3:
                try {
                    strRet = inCDSCode.substring(8, 15);
                } catch (Err) {}
                break;
        }
        console.log('fnParseCDSCode returning: ' + strRet);
        return strRet;
    }

    subscribers() {
        let schoolRegionsEntitiesSub = this.schoolRegionService.entities$.subscribe((schoolRegions: Region[]) => {
            this.allSchoolRegions = schoolRegions;
            this.schoolRegionIds = this.allSchoolRegions.length > 0 ? this.allSchoolRegions.map((schoolRegion) => schoolRegion.ID!) : [];
        });

        let schoolDistrictEntitiesSub = this.schoolDistrictService.entities$.subscribe((schoolDistricts: SchoolDistrict[]) => {
            this.allSchoolDistricts = schoolDistricts;
            this.schoolDistrictIds = this.allSchoolDistricts.length > 0 ? this.allSchoolDistricts.map((schoolDistrict) => schoolDistrict.ID!) : [];
        });

        let schoolCountyEntitiesSub = this.schoolCountyService.entities$.subscribe((schoolCounties: County[]) => {
            this.allSchoolCounties = schoolCounties;
        });
    }

    ngOnInit(): void {
        // reinit these starter booleans
        this.validGrades = false;
        this.scValid = true; // not valid would include blank or invalid
        this.ngChecking = false;
        this.ngChecked = false;
        this.ngValid = false;
        //  this.ncesValid = false;
        //  this.ncesChecked = false;
        //  this.ncesChecking = false;

        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            ///    this.getRegionsByPartyId();
        });

        // auth - check if allow the user admin operations
        this.fnCheckCanEditSchoolNCES();

        //     this.myControl = <FormControl>this.editSchoolsForm.get('username');

        //      this.filteredOptions = this.myControl.valueChanges.pipe(takeUntil(this.unsubUsername$)).subscribe((value: string) => {
        /*         let editUser: User = JSON.parse(JSON.stringify(this.user));
   
             if (editUser.USER_ID !== value) {
                 this.userIdChangedMsg.MSG = '* Your username will be updated. You will be required to login again.';
             } else {
                 this.userIdChangedMsg = {};
             }
       });
   */
        // removes the red line border on patterned UI components for UI consistency
        this.createSchoolsForm.get('txtSchoolCode')?.markAsUntouched();
        this.createSchoolsForm.get('schoolName')?.markAsTouched();
        this.createSchoolsForm.get('txtSchoolNCES')?.markAsTouched();
        this.createSchoolsForm.get('txtSchoolNcesFC')?.markAsTouched();
    }

    ngAfterViewInit(): void {
        // set school data
        setTimeout(() => {
            //   console.log("now calling fnsetinitialdata")
            this.getGeographicalRegion();
            this.fnSetInitialData();
        }, 1000);

        /*  console.log("schoolPropertyId:" + this.schoolPropertyID);
        console.log("schoolStatusId:" + this.schoolStatusId);*/
        console.log('closedDate:' + this.closedDate);
        //console.log("gradelow:" + this.gradeSpanLow);
        //console.log("gradehigh:" + this.gradeSpanHigh);
        //console.log("nces:" + this.NCES);
        //console.log("schoolCode:" + this.schoolCode);
        //console.log("editdata:" + Object.entries(this.editData))

        this.createSchoolsForm = new UntypedFormGroup({
            schoolDistrictNcesFC: new UntypedFormControl(null),
            chkSatelliteCampusFC: new UntypedFormControl(null),
            radioSchoolTypeFC: new UntypedFormControl(null),
            schoolNameFC: new UntypedFormControl(null),
            txtSchoolNcesFC: new UntypedFormControl(null),
            radioSchoolStatusFC: new UntypedFormControl(null),
            selectSubTypeFC: new UntypedFormControl({ value: '', disabled: true }), //
            selectLowGradeFC: new UntypedFormControl({ value: '', disabled: true }), // {value:'', disabled: true}
            selectHighGradeFC: new UntypedFormControl({ value: '', disabled: true }), //{value:'', disabled: true}
            txtSchoolCodeFC: new UntypedFormControl(null),
            txtStreet1FC: new UntypedFormControl(null),
            txtStreet2FC: new UntypedFormControl(null),
            txtCityFC: new UntypedFormControl(null),
            txtStateFC: new UntypedFormControl(null),
            txtZipcodeFC: new UntypedFormControl(null),
            txtFirstNameFC: new UntypedFormControl(null),
            txtLastNameFC: new UntypedFormControl(null),
            txtPhoneNumberFC: new UntypedFormControl(null),
            txtEmailFC: new UntypedFormControl(null),
            workEmail: new UntypedFormControl('valid', [Validators.required, Validators.email]),
            frmCloseDate: new UntypedFormControl(null),
            myRegion: new UntypedFormControl(null),
            myDistrict: new UntypedFormControl(null),
            myCounty: new UntypedFormControl(null)
        });
    }

    getGeographicalRegion() {
        this.contactMechanismsService.indexGeographicalRegions().subscribe((res) => {
            //console.log("getGrographicalRegion returned:")
            //console.log(res)
        });
    }

    getSchool(thisSchoolId: number) {
        console.log('passing in schoolid:' + thisSchoolId);
        this.schoolAPIService.show(thisSchoolId).subscribe((res) => {
            console.log('thisSchool: ');
            this.school = res.school;
            console.log(this.school);

            this.newTestDateFC = new UntypedFormControl(moment());
            console.log('newTestDateFC from getSchool:' + Object.entries(this.newTestDateFC));

            console.log('now parsing closedDate');
            this.closedDate = new CleanDatePipe().transform(this.school.CLOSE_DATE);
            console.log('parsed closedDate');
            if (this.closedDate) {
                var cleanDate = new Date(this.closedDate);
                console.log('my closed date from : ');
                console.log(cleanDate?.getTime());
                if (
                    cleanDate.getTime() == 31 ||
                    cleanDate.getTime() == -2208988800000 ||
                    cleanDate.getTime() == -62135596800000 ||
                    cleanDate.getTime().toString() == 'NaN'
                ) {
                    // invalid date
                    console.log('found an invalid date for datepicker');
                    console.log(cleanDate.getTime());
                    this.closedDate = '';
                } else {
                    this.newTestDateFC = new UntypedFormControl(moment([cleanDate.getFullYear(), cleanDate.getMonth(), cleanDate.getDay()])); // .setValue(cleanDate);
                    console.log('newTestDateFC from getSchool is now:' + Object.entries(this.newTestDateFC));
                }
            }
        });
    }

    getSpecificRegion(id: number): Region | null {
        for (var i = 0; i < this.allSchoolRegions.length; i++) {
            if (this.allSchoolRegions[i].ID) {
                if (this.allSchoolRegions[i].ID == id) {
                    return this.allSchoolRegions[i];
                }
            }
        }
        return null;
    }

    getSpecificCounty(id: number): County | null {
        for (var i = 0; i < this.allSchoolCounties.length; i++) {
            if (this.allSchoolCounties[i].ID == id) {
                return this.allSchoolCounties[i];
            }
        }
        return null;
    }

    getSpecificDistrict(id: number): SchoolDistrict | null {
        for (var i = 0; i < this.allSchoolDistricts?.length; i++) {
            if (this.allSchoolDistricts[i].ID == id) {
                return this.allSchoolDistricts[i];
            }
        }
        return null;
    }

    districtsSelected(districts: SchoolDistrict[]) {
        var associatedDistrict: any;

        if (districts[0] && this.child3?.selectedCountyName != undefined) {
            console.log('now checking district id');
            associatedDistrict = this.getSpecificDistrict(districts[0]?.ID);
            console.log(districts[0]?.ID);
            this.selectedNcesCode = associatedDistrict['NCESDist']; //this.school?.SCHOOL_DISTRICT?.NCESDist.toString();
            this.schoolDistrictNCES = this.selectedNcesCode;
            this.fnCheckNCESDistrictCode();
            /* console.log(this.selectedNcesCode)
             console.log(this.schoolDistrictNCES)
             console.log("done checking districts")*/
            //this.eventEmitterDistrictcode.emit(districts);
        }
    }

    countiesSelected(counties: County[]) {
        console.log('counties emitting');
        this.eventEmitterCountycode.emit(counties);
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    regionEventEmitter(lstRegion: any) {
        console.log('regions emitting');
        this.loadingCounter = this.loadingCounter + 1;
        if (this.loadingCounter > 2 && this.child3.selectedCountyName == undefined) {
            this.selectedSchoolDistrict = 0;
        }
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    fnCreate() {
        this.myError = '';
        this.createBtnText = 'Create';
    }

    fnSaveCreate() {
        this.myError = ''; // this needs to be cleared each time prior to a new save

        // first check grade selection
        if (!this.fnValidateGrades()) {
            console.log('showing error for grades');
            this.myError = 'Low grade cannot be greater than high grade.';
        }

        let inOrgId: number = this.organizationId;
        let inSchoolName: string = this.schoolName;

        //console.log("inCdsCode came in as: " + inCdsCode);

        let inSchoolNCES: string = this.schoolNCES;
        let inRadioSchoolType: string = this.schoolType?.toString();
        let inRadioSchoolStatus: string = this.schoolStatus?.toString();
        let inSelectSubType: string = this.selectedSubTypeItem?.toString();
        let inSelectLowGrade: number = parseInt(this.selectLowGradeFC?.value);
        let inSelectHighGrade: number = parseInt(this.selectHighGradeFC?.value);

        let inTxtStreet1: string = this.txtStreet1;
        let inTxtStreet2: string = this.txtStreet2;
        let inTxtCity: string = this.txtCity;
        let inTxtState: string = this.txtState;
        let inTxtZipcode: string = this.txtZipcode;
        let inTxtFirstName: string = this.txtFirstName;
        let inTxtLastName: string = this.txtLastName;
        let inTxtPhoneNumber: string = this.txtPhoneNumber;
        let inTxtEmail: string = this.txtEmail;

        //console.log("inSelectLowGrade came in as: " + inSelectLowGrade);
        //console.log("inSelectHighGrade came in as: " + inSelectHighGrade);
        // console.log("inRadioSchoolStatus came in as: " + inRadioSchoolStatus);
        //console.log("inRadioSchoolType came in as: " + inRadioSchoolType);
        //console.log("inSelectSubType came in as: " + inSelectSubType);
        let inCloseDate: string = '';
        if (this.schoolStatus == 2) {
            inCloseDate = this.validateClosedDate();
        }
        let inTxtSchoolCode: string = this.schoolCode;

        this.fnTogglePublicOrPrivateSubTypes(); // this checks school code

        let inChkSatelliteCampus: string;
        if (this.satelliteCampus) {
            inChkSatelliteCampus = 'true';
        } else {
            inChkSatelliteCampus = 'false';
        }
        //console.log("satelliteCampus will save using:" + inChkSatelliteCampus)

        /* if (inSchoolName) inSchoolName = inSchoolName?.trim();
      
        if (inSchoolNCES) inSchoolNCES = inSchoolNCES?.trim();*/
        if (inRadioSchoolType) inRadioSchoolType = inRadioSchoolType?.trim();
        if (inRadioSchoolStatus) inRadioSchoolStatus = inRadioSchoolStatus?.trim();
        if (inSelectSubType) inSelectSubType = inSelectSubType?.trim();
        if (inTxtSchoolCode) inTxtSchoolCode = inTxtSchoolCode?.trim();
        if (inChkSatelliteCampus) inChkSatelliteCampus = inChkSatelliteCampus?.trim();

        this.school = new School();

        if (inOrgId != null) {
            this.school.ORGANIZATIONS_ID = inOrgId;
        }
        if (inSchoolName != null) {
            this.school.NAME = inSchoolName;
        }
        if (inSchoolNCES != null) {
            this.school.SCHOOL_NCES = inSchoolNCES;
        }

        if (inRadioSchoolType != null) {
            this.school.SCHOOL_TYPE_ID = parseInt(inRadioSchoolType);

            let mySchoolType: SCHOOL_TYPE = new SCHOOL_TYPE();
            mySchoolType.ID = this.school.SCHOOL_TYPE_ID;
            this.school.SCHOOL_TYPE = mySchoolType;
        }

        //  console.log("this.school:")
        //  console.log(this.school)
        /*
        if (inRadioSchoolStatus != null) {
            let mySchoolStatusType: SCHOOL_STATUS_TYPE = new SCHOOL_STATUS_TYPE();
			mySchoolStatusType = createSchool?.SCHOOL_STATUS_TYPES;
            console.log("mySchoolStatusType:")
            console.log(mySchoolStatusType)
            
            mySchoolStatusType.ID = parseInt(inRadioSchoolStatus);
            switch (mySchoolStatusType.ID) {
                case 1:
                    mySchoolStatusType.DESCRIPTION = 'Open';
                    break;
                case 2:
                    mySchoolStatusType.DESCRIPTION = 'Close/Merged';
                    break;
            }
            this.school.SCHOOL_STATUS_TYPES = mySchoolStatusType;

        }
        */
        if (this.schoolStatus == 1) {
            // if it is an open school , blank out the closed date
            this.closedDate = '';
        }

        ///console.log("inSelectSubType:")
        ///console.log(inSelectSubType)

        if (inSelectSubType) {
            let mySchoolType: SCHOOL_TYPE = new SCHOOL_TYPE();
            mySchoolType = this.school.SCHOOL_TYPE;
            if (mySchoolType) {
                ///console.log(Object.entries(this.subTypeItems))
                ///console.log("checking subTypeItems:")
                ///console.log(this.subTypeItems)
                let myInd: number = this.subTypeItems.findIndex((x) => x.ID == parseInt(inSelectSubType));
                ///console.log("myInd:" + myInd)
                mySchoolType.ID = parseInt(inSelectSubType);
                if (this.subTypeItems[myInd]?.DESCRIPTION != undefined) {
                    mySchoolType.DESCRIPTION = this.subTypeItems[myInd].DESCRIPTION;
                }
                mySchoolType.CREATED_BY = this.subTypeItems[myInd]?.CREATED_BY;
                mySchoolType.CREATED_DATE = this.subTypeItems[myInd]?.CREATED_DATE;
                mySchoolType.IS_OTHER_TYPE = this.subTypeItems[myInd]?.IS_OTHER_TYPE;
                mySchoolType.MODIFIED_BY = this.subTypeItems[myInd]?.MODIFIED_BY;
                mySchoolType.MODIFIED_DATE = this.subTypeItems[myInd]?.MODIFIED_DATE;
                mySchoolType.OTHER_ID = this.subTypeItems[myInd]?.OTHER_ID;
                mySchoolType.TYPE = this.subTypeItems[myInd]?.TYPE;
                if (mySchoolType.ID == 0) {
                    this.school.SCHOOL_TYPE_OTHERS = '';
                } else {
                    this.school.SCHOOL_TYPE_OTHERS = mySchoolType;
                }
            }
        } else {
            let mySchoolType: SCHOOL_TYPE = new SCHOOL_TYPE();
            mySchoolType.DESCRIPTION = '';
            mySchoolType.ID = 1;
            mySchoolType.TYPE = '';
            this.school.SCHOOL_TYPE_OTHERS = mySchoolType;
        }

        if (inSelectLowGrade != null) {
            this.school.LOW_GRADE = this.gradeSpanLow;
            const thisGrade: any = this.gradeItems.find(({ ID }) => ID === this.gradeSpanLow);
            this.school.LOW_GRADES = thisGrade;
        }
        if (inSelectHighGrade != null) {
            this.school.HIGH_GRADE = this.gradeSpanHigh;
            const thisGrade: any = this.gradeItems.find(({ ID }) => ID === this.gradeSpanHigh);
            this.school.HIGH_GRADES = thisGrade;
        }
        if (inTxtSchoolCode != null) {
            this.school.SCHOOL_CODE = parseInt(inTxtSchoolCode); // .SCHOOL_CODE;
        }
        if (inChkSatelliteCampus != null) {
            //console.log("satellite campus:")
            //console.log(this.satelliteCampus)
            this.myPropType = new SCHOOL_PROPERTY_TYPE();
            this.myPropType.ID = this.satelliteCampus ? 1 : 2;
            if (this.myPropType.ID == 2) {
                this.myPropType.TYPE = 'Regular';
            } else {
                this.myPropType.TYPE = 'Satellite Campus';
            }
            //console.log("now setting inChkSatelliteCampus:" + this.myPropType.ID)
            this.school.SCHOOL_PROPERTY_TYPES = this.myPropType; // .SCHOOL_PROPERTY_TYPES;

            this.school.SCHOOL_PROPERTY_ID = this.myPropType.ID;
        }

        if (this.school?.REGIONS?.ID) {
            if (this.school.SCHOOL_PROPERTY_ID) {
                this.school.SCHOOL_PROPERTY_ID = 1;
            } else {
                this.school.SCHOOL_PROPERTY_ID = 2;
            }
        }
        console.log('about to save closedate');
        console.log(inCloseDate);
        if (inCloseDate != null && inCloseDate != '') {
            var cleanDate = new Date(inCloseDate);
            var inDate = new Date();
            //editSchool.CLOSE_DATE = cleanDate.getTime().toString();
            inDate = new Date(
                moment().format(
                    cleanDate.getUTCFullYear() +
                        '-' +
                        this.pad(cleanDate.getUTCMonth() + 1) +
                        '-' +
                        this.pad(cleanDate.getUTCDate()) +
                        ' ' +
                        this.pad(cleanDate.getUTCHours()) +
                        ':' +
                        this.pad(cleanDate.getUTCMinutes()) +
                        ':' +
                        this.pad(cleanDate.getUTCSeconds())
                )
            );
            this.mySchoolStatus = new SCHOOL_STATUS();
            this.mySchoolStatus.CLOSE_DATE = inDate;
            this.school.SCHOOL_STATUS = this.mySchoolStatus;
        }

        if (this.checkValid()) {
            let inCounties: string = this.child3.selectedCountyIds.toString();
            let inCountyName: string = this.child3.selectedCountyName || '';
            let inRegions: string = this.child2.selectedRegionIds.toString();
            let inRegionName: string = this.child2.selectedRegionName || '';
            let inDistrict: string = this.child.selectedSchoolDistrictName || '';
            let inDistrictID: number[] = this.child.selectedSchoolDistrictIds || '';

            let inSchoolName: string = this.createSchoolsForm.controls['schoolNameFC'].value;
            let inSchoolDistrictNCES: string = this.schoolDistrictNCES;

            let inLowGrade: string = this.createSchoolsForm.controls['selectLowGradeFC'].value;
            let inHighGrade: string = this.createSchoolsForm.controls['selectHighGradeFC'].value;
            let inSchoolNCES: string = this.createSchoolsForm.controls['txtSchoolNcesFC'].value;
            let inSchoolType: string = this.createSchoolsForm.controls['radioSchoolTypeFC'].value;
            let inSchoolSatelliteCampus: string = this.createSchoolsForm.controls['chkSatelliteCampusFC'].value;

            let inStreet1: string = this.createSchoolsForm.controls['txtStreet1FC'].value;
            let inStreet2: string = this.createSchoolsForm.controls['txtStreet2FC'].value;
            let inCity: string = this.createSchoolsForm.controls['txtCityFC'].value;
            let inState: string = this.createSchoolsForm.controls['txtStateFC'].value;
            let inEmail: string = this.createSchoolsForm.controls['txtEmailFC'].value;
            if (!inStreet1) {
                inStreet1 = this.txtStreet1;
            }
            if (!inStreet2) {
                inStreet2 = this.txtStreet2;
            }

            if (!inEmail) {
                inEmail = this.emailChild.email;
                this.txtEmail = inEmail;
                console.log('setting email to:' + inEmail);
            } else {
                this.txtEmail = inEmail;
            }

            let inPhoneNumber: string = this.createSchoolsForm.controls['txtPhoneNumberFC'].value;

            // this.createSchoolsForm.controls["schoolName"].value;
            /* console.log('incoming district nces:' + inSchoolDistrictNCES);
                console.log('incoming counties:' + inCounties.trim());
                console.log('incoming regions:' + inRegions.toString());
                console.log('incoming district :' + inDistrict);
                console.log('incoming district ids :' + inDistrictID);
                    */
            var editRegion: any;
            editRegion = this.chosenRegions[0];

            var editCounty: any;
            editCounty = this.chosenCounties[0];

            var createDistrict: any;
            createDistrict = this.chosenSchoolDistricts[0];

            let params: any;

            this.school.REGION = editRegion['CODE'];
            this.school.REGIONS = editRegion;

            let iContactMechIndex = 0;
            this.school?.ORGANIZATION?.PARTy?.PARTY_CONTACT_MECHANISMS.forEach((contactMech: ContactMechanisms) => {
                let myPostalAddress: POSTAL_ADDRESSES;

                iContactMechIndex = iContactMechIndex + 1;

                /*  if (contactMech.POSTAL_ADDRESSES) {
                      contactMech.POSTAL_ADDRESSES.STREET_1 = this.txtStreet1;
                      contactMech.POSTAL_ADDRESSES.STREET_2 = this.txtStreet2;
                     
                      this.myCity.CITY_NAME = this.txtCity;
                      this.myCity.STATE.push(this.txtState);
                      this.myState.STATE_CODE = this.txtState;
                      contactMech.POSTAL_ADDRESSES.CITy = this.myCity;
                      contactMech.POSTAL_ADDRESSES.GEOGRAPHICAL_REGIONS
                      contactMech.POSTAL_ADDRESSES.POSTAL_CODES.push(this.txtZipcode);
                      contactMech.EMAILS.push(this.txtEmail);
                      contactMech.TELEPHONE_NUMBERS.push(this.txtPhoneNumber);
                     // contactMech.POSTAL_ADDRESSES
  
                      myPostalAddress = contactMech.POSTAL_ADDRESSES;
                      myPostalAddress.GEOGRAPHICAL_REGIONS_ID = editRegion;
                      let myGeographicalRegion: GEOGRAPHICAL_REGIONS;
                      myGeographicalRegion = myPostalAddress.GEOGRAPHICAL_REGIONS;
                      myGeographicalRegion.REGION = editRegion;
                      myPostalAddress.GEOGRAPHICAL_REGIONS = myGeographicalRegion;
                      this.schoolAddress = myPostalAddress;
  
                      console.log("School address set!")
                  }
                  else
                  {
                      console.log("School address not set!")
                  }
                  */
            });
            var cleanDate = new Date();
            this.txtCity = this.objCity?.CITY_NAME?.toString() || '';

            let paramsCity: any;
            paramsCity = {
                searchString: this.txtCity,
                countryId: 1,
                stateId: 1
            };

            this.schoolAPIService.searchCities(paramsCity).subscribe({
                next: (res: any) => {
                    this.myCity = res.cities[0];

                    this.myPostalAddress = new POSTAL_ADDRESSES();
                    this.myPostalAddress.CITy = this.myCity;
                    this.myPostalAddress.STREET_1 = this.txtStreet1;
                    this.myPostalAddress.STREET_2 = this.txtStreet2;
                    //this.myPostalAddress?.POSTAL_CODES_ID =
                    //this.myPostalAddress.POSTAL_CODES.push(this.txtZipcode);

                    this.myPostalAddress.GEOGRAPHICAL_REGIONS_ID = editRegion;
                    let myGeographicalRegion: GEOGRAPHICAL_REGIONS;
                    myGeographicalRegion = new GEOGRAPHICAL_REGIONS();
                    myGeographicalRegion.ID = 1;
                    myGeographicalRegion.REGION = 'WEST';

                    myGeographicalRegion.CREATED_DATE = cleanDate;
                    myGeographicalRegion.POSTAL_ADDRESSES = [];
                    myGeographicalRegion.STANDARDIZED_POSTAL_ADDRESSES = [];
                    //  myGeographicalRegion = this.myPostalAddress.GEOGRAPHICAL_REGIONS;
                    // myGeographicalRegion.REGION = this.school.REGION; //editRegion;
                    this.myPostalAddress.GEOGRAPHICAL_REGIONS = myGeographicalRegion;

                    let myPostalCode: POSTAL_CODE = new POSTAL_CODE();
                    myPostalCode.POSTAL_CODE = this.txtZipcode;
                    myPostalCode.CREATED_DATE = cleanDate;
                    myPostalCode.ACCOUNT_REQUESTS = [];
                    myPostalCode.POSTAL_ADDRESSES = [];
                    myPostalCode.STANDARDIZED_POSTAL_ADDRESSES = [];

                    let myCountry: Country = new Country();
                    myCountry.ID = 1;
                    myCountry.COUNTRY_NAME = 'United States';
                    myCountry.CREATED_DATE = cleanDate;
                    myCountry.COE_MOVEMENT_INFORMATION = [];
                    myCountry.POSTAL_ADDRESSES = [];
                    myCountry.PRE_SCREEN_MOVE_INFORMATION = [];
                    myCountry.POSTAL_CODES = [];
                    myCountry.PROVINCES = [];
                    myCountry.STATES = [];
                    myCountry.TERRITORIES = [];

                    myCountry.STATE = [];

                    myPostalCode.COUNTRY = myCountry;
                    let myPostalCodes: POSTAL_CODE[] = [];
                    myPostalCodes.push(myPostalCode);
                    this.myPostalAddress.POSTAL_CODES = myPostalCodes;
                    this.schoolAddress = this.myPostalAddress;

                    /// contactMech.POSTAL_ADDRESSES = myPostalAddress;

                    this.partyRoleService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
                        const type = this.type;
                        this.partyRoleType1 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                            // return prt.TYPE === type;
                            return prt.ID == 6;
                        });

                        this.partyRoleTypeSet = []; // set this to null because pushing 2 into the set will result in invalid ID error during save!
                        this.partyRoleTypeSet.push(this.partyRoleType1);

                        //this.school.REGIONS.ID = parseInt(inRegions);
                        //this.school.REGIONS.NAME = inRegionName;
                        //this.school.DISTRICT = inDistrict;
                        this.school.COUNTy = editCounty;

                        this.school.SCHOOL_DISTRICT = createDistrict;

                        this.districtsSelected = createDistrict;

                        // createDistrict.NCESDist = parseInt(inSchoolDistrictNCES);
                        // createDistrict.DISTRICTS= inDistrict;
                        this.school.SCHOOL_DISTRICT = createDistrict;
                        // set back school district nces after it was reset by selecting county/district
                        // this.schoolDistrictNCES = inSchoolDistrictNCES;
                        this.school.SCHOOL_NCES = inSchoolDistrictNCES;
                        console.log('backup being saved:');
                        console.log(this.schoolBackup);

                        // Setup ContactPerson and Address Objects
                        this.contactPerson = new ContactPerson();
                        this.contactPerson.FIRST_NAME = this.txtFirstName;
                        this.contactPerson.LAST_NAME = this.txtLastName;

                        this.school.STATE_NAME = this.txtState;
                        this.school.PHONE = this.txtPhoneNumber;
                        this.schoolAddress = this.myPostalAddress;

                        let mySchoolStatus: SCHOOL_STATUS = new SCHOOL_STATUS();
                        mySchoolStatus.ID = this.schoolStatus;
                        this.school.SCHOOL_STATUS = mySchoolStatus;
                        this.school.STATUS_ID = mySchoolStatus.ID;

                        Swal.fire({
                            title: 'Are you sure you want to save?',
                            showDenyButton: false,
                            showConfirmButton: true,
                            showCancelButton: true,
                            denyButtonText: ``
                        }).then((result) => {
                            if (result.isConfirmed && this.myError == '' && this.myGradeError == '' && this.myCloseDateError == '') {
                                let params: any;
                                params = {
                                    newSchool: this.school,
                                    contactPerson: this.contactPerson,
                                    partyRoleTypes: this.partyRoleTypeSet,
                                    schoolAddress: this.schoolAddress,
                                    schoolEmail: this.txtEmail,
                                    schoolPhone: this.txtPhoneNumber
                                };

                                this.schoolAPIService.createNewSchool(params).subscribe({
                                    next: (res: any) => {
                                        //console.log("checking api res message:")
                                        //console.log(res)
                                        //console.log(res.editSchool)
                                        if (!res.msg['SUCCESS']) {
                                            this.myError = res.msg['MSG'];
                                        } else {
                                            this.isCreated = true;
                                        }
                                    },
                                    error: (err: any) => {
                                        console.log('error while updating school data: ' + Object.entries(err));
                                    }
                                });
                            }
                        });

                        //console.log("checking api res message:")
                        //console.log(res)
                        //console.log(res.editSchool)
                    });
                },
                error: (err: any) => {
                    console.log('error while getting city data: ' + Object.entries(err));
                    this.myError = err;
                }
            });
        }
    }

    disableCreateButton() {
        let inRegions: string = this.child2?.selectedRegionIds?.toString();
        let inCounties: string = this.child3?.selectedCountyIds?.toString();
        let inDistricts: string = this.child?.selectedSchoolDistrictIds?.toString();
        let inSchoolName: string = this.schoolName;
        let inSchoolDistrictNCES: string = this.schoolDistrictNcesFC?.value;

        let inSchoolNCES: string = this.txtSchoolNcesFC?.value;
        let inSchoolType: number = this.schoolType;
        let inSchoolStatus: number = parseInt(this.radioSchoolStatusFC?.value);
        let inSchoolCodeFC: string = this.txtSchoolCodeFC?.value;
        let inSchoolStreet1: string = this.txtStreet1FC?.value;
        let inSchoolStreet2: string = this.txtStreet2FC?.value;
        let inSchoolCity: string = this.objCity?.CITY_NAME?.toString() || '';
        let inSchoolZip: string = this.objZipcode?.POSTAL_CODE?.toString() || '';

        let inGradeLow: number = parseInt(this.selectLowGradeFC?.value);
        let inGradeHigh: number = parseInt(this.selectHighGradeFC?.value);
        // let inSchoolCode: string = this?.value;
        /*    
               console.log("school name check")
                console.log(inSchoolName)
                console.log(inSchoolDistrictNCES)
                console.log("schoolType check:")
                console.log(inSchoolType)
            console.log("inRegions:");
            console.log(inRegions);
            console.log("inCOunties:");
            console.log(inCounties);
            console.log("inDistricts");
            console.log(inDistricts);
            console.log("inSchoolDistrictNCES");
            console.log(inSchoolDistrictNCES);
            console.log("inSchoolCity:");
            console.log(inSchoolCity);
            console.log("inSchoolStreet1:")
            console.log(inSchoolStreet1);
            console.log("inSchoolName:");
            console.log(inSchoolName);
            console.log("inSchoolZip");
            console.log(inSchoolZip);
            console.log("inGradeLow:");
            console.log(inGradeLow);
            console.log("inGradeHigh:");
            console.log(inGradeHigh);
            console.log("inSchoolType:");
            console.log(inSchoolType);
            console.log("inSchoolStatus:");
            console.log(inSchoolStatus);
            console.log("inSchoolCodeFC:");
            console.log(inSchoolCodeFC);
            console.log("bCustomSchoolCodeError:");
            console.log(this.bCustomSchoolCodeError);
        */
       if (
            inRegions?.length > 0 &&
            inCounties?.length > 0 &&
            inDistricts?.length > 0 &&
            inSchoolDistrictNCES?.length > 0 &&
            inSchoolCity?.length > 0 &&
            inSchoolStreet1?.length > 0 &&
            inSchoolName?.length > 0 &&
            inSchoolZip?.length > 0 &&
            inGradeLow > 0 &&
            inGradeHigh > 0 &&
            inSchoolType > 0 &&
            inSchoolStatus > 0 &&
            inSchoolCodeFC?.length > 0 &&
            !this.bCustomSchoolCodeError &&
            this.strCustomSchoolCodeError.length == 0
        ) {
            this.bDisableCreateButton = false;
            return false;
        }

        /*     console.log("missing one required field:");
              (!inRegions) ? console.log("N-inRegions") : '';
              (!inCounties) ? console.log("N-inCounties") : '';
              (!inDistricts) ? console.log("N-inDistricts") : '';
              (!inSchoolName) ? console.log("N-inSchoolName") : '';
              (!inDistricts) ? console.log("N-inDistricts") : '';
              (!inSchoolDistrictNCES) ? console.log("N-inSchoolDistrictNCES") : '';
              (!inSchoolNCES) ? console.log("N-inSchoolNCES") : '';
              (!inSchoolStreet1) ? console.log("N-inSchoolStreet1") : '';
              (!inSchoolCity) ? console.log("N-inSchoolCity") : '';
              (!inSchoolZip) ? console.log("N-inSchoolZip") : '';
              (!inGradeLow) ? console.log("N-inGradeLow") : '';
              (!inGradeHigh) ? console.log("N-inGradeHigh") : '';
              (!inSchoolType) ? console.log("N-inSchoolType") : '';
              (!inSchoolStatus) ? console.log("N-inSchoolStatus") : '';
              (!inSchoolCodeFC) ?  console.log("N-inSchoolCodeFC") : '';
              (!this.bCustomSchoolCodeError) ?  console.log("N-bCustomSchoolCodeError") : '';
              (!this.strCustomSchoolCodeError) ?  console.log("N-strCustomSchoolCodeError") : ''; */
        this.bDisableCreateButton = true;
        return true;
    }

    fnSetInitialData() {
        // console.log('setting initial school data');

        this.isLoading = true;
        this.bCustomSchoolCodeError = false;
        this.strCustomSchoolCodeError = '';
        this.schoolNameFC.reset(); //.setValue(""); <-- this works
        this.schoolDistrictNcesFC.reset(); //.setValue (""); <-- this works
        this.txtSchoolNcesFC.reset();
        this.txtSchoolCodeFC.reset();
        this.chkSatelliteCampusFC.reset();
        this.txtStreet1FC.setValue('');
        this.txtStreet2FC.setValue('');
        this.txtCityFC.setValue('');
        this.txtZipcodeFC.setValue('');
        this.objCity.CITY_NAME = '';
        this.objZipcode.POSTAL_CODE = '';
        this.txtStateFC.setValue('CA'); // per Victor, this should be hardcoded to CA

        this.objCountry.ID = 1;
        this.objCountry.COUNTRY_NAME = 'United States';
        this.objCountry.COUNTRY_CODE = 'USA';
        this.objCountry.CREATED_DATE = new Date();

        this.objState.ID = 1;
        this.objState.STATE_NAME = 'California';
        this.objState.CREATED_DATE = new Date();
        this.objState.COUNTRy = this.objCountry;
        this.objState.STATE_CODE = 'CA';

        this.txtFirstNameFC.setValue('');
        this.txtLastNameFC.setValue('');
        this.txtPhoneNumberFC.setValue('');
        this.txtEmailFC.setValue('');
        this.txtSchoolNcesFC.setValue('');

        this.radioSchoolTypeFC.setValue(1);
        this.schoolType = 1;
        this.schoolTypeID = 1;
        this.schoolStatus = 0;
        this.radioSchoolTypeFC.reset();
        this.radioSchoolStatusFC.reset();
        this.txtSchoolCodeFC.reset();
        this.closedDate = '';

        this.gradeSpanLow = 0;
        this.gradeSpanHigh = 0;

        // this.txtFirstName = "";
        // this.txtLastName = "";

        // this.fnCheckNCESDistrictCode();

        // backup for screenBackup save functionality
        /*this.schoolBackup = JSON.parse(JSON.stringify(this.school));
        console.log("new backup set for school");
        console.log(this.schoolBackup);
        */

        this.organizationService.getGradesTable().subscribe({
            next: (res: any) => {
                this.gradeItems = res.grades;
            },
            error: (err: any) => {
                console.log('error getting grades:' + Object.entries(err));
            }
        });

        this.schoolAPIService.getOtherSubtypes().subscribe({
            next: (res: any) => {
                this.subTypeItems = res.schoolTypeOthers;
            },
            error: (err: any) => {
                console.log('error getting otherSubTypes:' + Object.entries(err));
            }
        });

        this.schoolAPIService.getSchoolStatus().subscribe({
            next: (res: any) => {
                // this.subTypeItems = res.schoolTypeOthers;
            },
            error: (err: any) => {
                console.log('error getting school statuses:' + Object.entries(err));
            }
        });

        this.isLoading = false;
    }

    fnReset() {
        setTimeout(() => {
            this.fnSetInitialData();
            this.child2.deSelectAll();
            this.child.deSelectAll();
            this.child3.deSelectAll();
        }, 1000);
    }

    getPartyRoles() {
        console.log('getting party roles for user:' + Object.entries(this.user));
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got party roles:' + res.partyRoles);
            }
        });
    }

    getRegionsByPartyId() {
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
            }
        });
    }

    fnCancelCreate() {
        this.bCancelCreate = !this.bCancelCreate;
        Swal.fire({
            title: 'Are you sure you want to stop editing and discard all changes made?',
            showDenyButton: true,
            showConfirmButton: false,
            showCancelButton: true,
            denyButtonText: `Confirm`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');
                this.isUneditable = !this.isUneditable;
                this.fnReset();
            }
        });
    }

    // for Auth
    fnCheckCanEditSchoolNCES() {
        // until sec roles have been implemented, we will set this as true
        this.canEditSchoolNCES = true;
    }

    validateClosedDate() {
        console.log('school form controls:');
        console.log(this.createSchoolsForm.controls);
        let inCloseDate: string = this.createSchoolsForm.controls['frmCloseDate'].value || this.closedDate;
        console.log('inCloseDate came in as: ' + inCloseDate);
        if ((inCloseDate == null || inCloseDate == '') && this.schoolStatus != 1) {
            this.myError = 'There are missing fields. Please check your input.';
            this.myCloseDateError = 'Close Date is required.';
        } else {
            this.myCloseDateError = '';
            this.myError = '';
        }
        return inCloseDate;
    }

    fnValidateGrades() {
        this.validateGrades();
        return this.validGrades;
    }

    validateGrades() {
        let iLowGrade: number = this.gradeSpanLow;
        let iHighGrade: number = this.gradeSpanHigh;

        if (iLowGrade > 0 && iHighGrade > 0) {
            if (iLowGrade > iHighGrade) {
                this.myGradeError = 'Low grade cannot be greater than high grade.';
                this.validGrades = false;
            } else {
                this.validGrades = true;
            }
        } else {
            this.validGrades = true;
        }

        return this.validGrades;
    }

    catchSubmitError(err: any) {
        console.log('submit edits caught error:' + err);
        this.myError = 'Error during submit:' + err;
    }

    checkSchoolCode(evt?: any) {
        if (!this.bAllowSC) {
            console.log('checkSchoolCode preventing default');
            evt.preventDefault();
        } else {
            this.myError = '';
            this.ngChecking = true;
            this.fnTogglePublicOrPrivateSubTypes();
        }
    }

    checkSchoolCodeOnKey(evt: any, newChar: string) {
        console.log('checkSchoolCodeOnKey');
        if (!this.bAllowSC) {
            console.log('preventing default');
            evt.preventDefault();
        } else {
            this.myError = '';
            this.ngChecking = true;
            this.fnTogglePublicOrPrivateSubTypes(newChar);
        }
    }

    fnResetForCreateAnother() {
        setTimeout(() => {
            this.child2.deSelectAll();
            this.schoolCode = this.resetSchoolCode;
            this.child3.deSelectAll();
            this.createSchoolsForm.reset();

            //          this.txtStreet1 = "";
            //          this.txtStreet2 = "";

            /*this.txtCity = "";
            this.txtState = "";
            this.txtZipcode = "";
            */
            /*
            this.childCity.selectedCity = new City();
            this.childState.selectedState = new State();
            this.childZip.selectedZipcode = new PostalCode2();

            this.txtFirstName = "";
            this.txtLastName = "";
            this.txtPhoneNumber = "";
            
            this.schoolName = ""; */
            //this.createSchoolsForm.controls['selectLowGradeFC'].reset();
            //this.createSchoolsForm.controls['selectHighGradeFC'].reset();
            //this.childLowGrade.empty();
            //this.childHighGrade.empty();

            this.fnReset();
        }, 1500); // 2000
    }

    closeRecord() {
        Swal.fire({
            title: 'Are you sure you want to stop editing and discard all changes made?',
            showDenyButton: true,
            showConfirmButton: false,
            showCancelButton: true,
            denyButtonText: `Confirm`
        }).then((result) => {
            console.log('now closing way');
            if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');

                this.fnReset();
                console.log('now closing way b');
                this.dialogRef.close();
            }
            if (result.isConfirmed) {
                console.log('now closing way c');
                this.dialogRef.close();
            } else {
                // do nothing except close popup swal confirmation
                console.log('now closing way d');
            }
        });
    }

    ngOnDestroy(): void {
        this.unsubUsername$.next();
        this.unsubUsername$.complete();
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    checkCityValid(searchParm: string) {
        let bRet: boolean = false;
        var cleanDate = new Date();

        let paramsCity: any;
        paramsCity = {
            searchString: searchParm,
            countryId: 1,
            stateId: 1
        };

        console.log(paramsCity);
        this.schoolAPIService.searchCities(paramsCity).subscribe({
            next: (res: any) => {
                this.myCity = res.cities[0];
                bRet = true;
            }
        });
        return bRet;
    }

    checkDistrictNCESValid() {
        console.log('checkDistrictNCESValid');
        console.log(this.schoolDistrictNCES);
        let ncesLen = this.schoolDistrictNCES?.toString().length;

        if (ncesLen > 0) {
            if (ncesLen < 7) {
                this.myError = 'School District NCES is 7 characters long.';
                return false;
            } else {
                return true;
            }
        } else {
            console.log('checkdistrictncesvalid returning false');
        }
        return false;
    }

    fnCheckNCESDistrictCode(evt?: Event, pastedText?: string) {
        this.ncesValid = false;
        this.myError = '';
        this.ncesChecking = true;

        console.log('checking ncesdistrictcode for:' + this.schoolDistrictNCES);
        if (pastedText && pastedText.length > 0) {
            this.schoolDistrictNCES = pastedText;
        }
        if (!this.schoolDistrictNCES) {
            console.log('nces code had blank inputs');

            this.myError = 'Error checking NCES District Code:  ncesCode was blank for this school.';
            this.ncesValid = false;
        } else {
            this.schoolAPIService.checkDistrictNCES(parseInt(this.schoolDistrictNCES), this.schoolID).subscribe({
                next: (res: any) => {
                    setTimeout(() => {
                        if (res.msg['SUCCESS'] == false) {
                            this.myError = 'Error checking nces district Code:' + res.msg['MSG'];
                            this.ncesValid = false;
                            this.ncesChecking = false;
                        } else {
                            this.ncesValid = true;
                            this.ncesChecking = false;
                            this.ncesChecked = true;
                        }
                    }, 2000);
                },
                error: (err: any) => {
                    setTimeout(() => {
                        this.myError = 'Error checking NCES District Code, please try again.';
                        this.ncesValid = false;
                        this.ncesChecking = false;
                    }, 2000);
                }
            });
        }
    }

    fnRunSchoolNCESCheck(e: any, inputChar: any, pastedText?: string) {
        console.log('fnRunSchoolNCESCheck');
        console.log(inputChar);
        console.log(pastedText);
        let incLen: number = 1;
        let bIsBackSpace: boolean = false;

        if (e.key == 'Backspace') {
            bIsBackSpace = true;
            incLen = -1;
        }
        var testLen = this.schoolNCES?.length + incLen;
        if (pastedText) {
            console.log('pasted text:');
            console.log(pastedText);
            testLen = pastedText?.length;
            this.schoolNCES = '0';
            this.schoolNCES = pastedText;
        }
        if (!testLen || testLen == 7 || (bIsBackSpace && testLen == 8)) {
            console.log('calling checkSchoolNCESOnKey');
            //this.checkSchoolNCESOnKey(this.txtSchoolNcesFC, inputChar);
        } else if (testLen > 5) {
            if (!this.utilityService.isValidKeys(e)) {
                e.preventDefault();
            }
        }
    }

    checkValid() {
        let retVal: boolean = true;
        retVal = this.checkDistrictNCESValid();
        //console.log("checkValid returning:")
        //console.log(retVal);
        if (!retVal) {
            this.myError = 'There are errors, please check your input(s).';
        }
        return retVal;
    }

    onPasteNCESCode(e: ClipboardEvent) {
        e.preventDefault();
        let clipboardData = e.clipboardData;
        let pastedText = clipboardData?.getData('text');
        //console.log("onPasteSchoolCode")
        //console.log(pastedText)

        if (pastedText && pastedText.length > 0) {
            this.schoolDistrictNCES = pastedText;
        }

        this.myError = '';
        this.fnCheckNCESDistrictCode(e, pastedText);
    }

    onPasteSchoolCode(e: ClipboardEvent) {
        e.preventDefault();
        let clipboardData = e.clipboardData;
        let pastedText = clipboardData?.getData('text');
        console.log('onPasteSchoolCode');
        console.log(pastedText);

        this.myError = '';
        this.fnRunSchoolCodeCheck(e, '', pastedText);
    }

    fnRunSchoolCodeCheck(e: any, inputChar: any, pastedText?: string) {
        /*console.log("fnRunSchoolCodeCheck")
        console.log(inputChar)
        console.log(pastedText)*/
        let incLen: number = 1;
        let bIsBackSpace: boolean = false;

        if (e.key == 'Backspace') {
            bIsBackSpace = true;
            incLen = -1;
        }
        var testLen = this.schoolCode?.length + incLen;
        if (pastedText) {
            console.log('pasted text:');
            console.log(pastedText);
            testLen = pastedText?.length;
            this.schoolCode = '0';
            this.schoolCode = pastedText;
        }
        if (!testLen || testLen == 7 || (bIsBackSpace && testLen == 8)) {
            // console.log("calling checkSchoolCodeOnKey")
            this.checkSchoolCodeOnKey(this.txtSchoolCodeFC, inputChar);
        } else if (testLen > 7) {
            if (!this.utilityService.isValidKeys(e)) {
                e.preventDefault();
            }
        }
    }

    onKeyDown(e: any) {
        const pattern = /[0-9\+\-\ ]/;
        if (e.key) {
            // console.log(e.key)
            let inputChar = e?.key?.toString();

            // reset errors here
            this.strCustomSchoolCodeError = '';
            this.bCustomSchoolCodeError = false;
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyDown');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'schoolDistrictNCES') {
                    this.fnCheckNCESDistrictCode(e);
                } else if (e.srcElement.id == 'txtCity') {
                    this.checkCityValid(this.txtCity);
                } else if (e.srcElement.id == 'txtSchoolCode') {
                    this.fnRunSchoolCodeCheck(e, inputChar);
                } else if (e.srcElement.id == 'txtSchoolNCES') {
                    this.fnRunSchoolNCESCheck(e, inputChar);
                }
            }
        }
    }

    onKeyDownCity(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/;
        // console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyDownCity');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'txtCity') {
                    this.checkCityValid(this.txtCity);
                }
            }
        }
    }

    onKeyDownNames(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/;
        // console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyDownNames');
                e.preventDefault();
            }
        }
    }

    onKeyUpNames(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/;
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyUpNames');
                e.preventDefault();
            }
        }
        if (e.srcElement.value.length >= e.srcElement.maxLength) {
            console.log('prevent');
            e.preventDefault();
        }
    }

    onKeyUp(e: any) {
        if (e.srcElement.value.length >= e.srcElement.maxLength) {
            e.preventDefault();
        }
    }

    fnDeactivateInitialLoad() {
        this.isInitialLoad = false;
        this.loadingCounter = 4;
    }

    getFormValidationErrors(form: UntypedFormGroup) {
        if (form) {
            type newObj = { [key: string]: any };

            let res: newObj = {};

            Object.keys(form.controls).forEach((key: string) => {
                if (key.trim() != 'txtErrorMsg') {
                    let controlErrors: ValidationErrors = <UntypedFormControl>form.get(key)!.errors;
                    if (controlErrors != null) {
                        console.log('control errors');
                        console.log(controlErrors);
                        Object.keys(controlErrors).forEach((keyError) => {
                            if (keyError == 'pattern') {
                                console.log('no error');
                            } else {
                                res[key] = keyError;
                                console.log('found errors');
                                console.log('for control');
                                console.log(key);
                                console.log(keyError);
                            }
                        });
                    }
                }
            });
            console.log('getFormValidation errors returning');
            console.log(Object.keys(res).length);
            console.log(res);
            return Object.keys(res).length === 0 ? null : res;
        } else {
            console.log('getFormValidation errors returning null');
            return null;
        }
    }

    fnTogglePublicOrPrivateSubTypes(optionalKey?: string) {
        this.scValid = false;
        let schoolCodeToCheck: string = this.schoolCode;
        if (optionalKey) {
            schoolCodeToCheck = schoolCodeToCheck + '' + optionalKey;
        }

        if (!schoolCodeToCheck) {
            // || !this.schoolID
            console.log('had blank inputs');
            var customMsg = '';
            if (!schoolCodeToCheck) {
                customMsg = customMsg + 'schoolCode,';
            }
            if (!this.schoolID) {
                customMsg = customMsg + 'schoolID, ';
            }
            this.myError = 'Error checking School Code:  ' + customMsg + ' was blank for this school.';
            this.scValid = false;
        } else {
            this.schoolAPIService.checkSchoolCode(parseInt(schoolCodeToCheck), this.schoolID).subscribe({
                next: (res: any) => {
                    if (res.msg['SUCCESS'] == false) {
                        if (!(res.msg['MSG'].toString().toLowerCase().indexOf('already exists') > 0)) {
                            this.myError = 'Error checking School Code:' + res.msg['MSG'];
                        } else {
                            this.bCustomSchoolCodeError = true;
                            this.strCustomSchoolCodeError = res.msg['MSG'];
                        }
                        this.scValid = false;
                        this.ngValid = false;
                        this.ngChecking = false;
                    } else {
                        this.scValid = true;
                        this.ngChecking = false;
                        this.ngChecked = true;
                        this.ngValid = true;
                    }
                },
                error: (err: any) => {
                    this.myError = 'Error checking School Code, please try again.';
                    this.scValid = false;
                    this.ngValid = false;
                    this.ngChecking = false;
                }
            });
        }
    }

    fnToggleSubTypes() {
        console.log('now incrementing iToggleSCValid3');
        // handle radio button
        this.iToggleSCValid3 = this.iToggleSCValid3 + 1;

        if (this.iToggleSCValid3 > 2) {
            this.iToggleSCValid3 = 0;
        }
    }

    showValuePromptText(inStr: string, evt: Event) {
        ///console.log("called showValue:" + inStr + ":" + evt)
        this.myGradeError = '';
        this.fnValidateGrades();
    }

    recheckClosedDate(evt: Event) {
        this.myCloseDateError = '';
        let inCloseDate: string = this.validateClosedDate();
        console.log('inCloseDate check:' + inCloseDate);
    }

    pad(num: number) {
        return ('00' + num).slice(-2);
    }

    addEvent(type: string, event: any) {
        console.log('now changing date day');
        this.events.push(`${type}: ${event}`);
    }

    fnClickDateToday() {
        this.serializedDate = new UntypedFormControl(new Date().toISOString());
    }

    fnClearDateField() {
        this.createSchoolsForm.controls['frmCloseDate'].setValue('');
        this.closedDate = '';
        console.log('now rechecking closed date');
        let inCloseDate: string = this.validateClosedDate();
    }

    fnFigureRadioSchoolChecked(evt: Event, opId: number, schoolType: number): boolean {
        console.log("calling fnFigureRadioSchoolChecked for " + opId)
        let bRet: boolean = true;
        switch (opId) {
            case 1:
                this.fnToggleAndCheck(1);
                this.bDisAllowSubTypes = true;
                this.schoolType = 1;
                if (this.radioOptionsSchoolType['0'].checked == true) {
                    this.bAllowSC = true;
                    this.bCheckedSCCode1 = true;
                    this.schoolType = 1;
                    this.scValid = true;
                    this.radioOptionsSchoolType['1'].checked = false;
                    this.radioOptionsSchoolType['2'].checked = false;
                    this.iToggleSCValid2 = 0;
                    this.iToggleSCValid3 = 0;
                    this.bCheckedSCCode2 = false;
                    this.bCheckedSCCode3 = false;
                  //  evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                    console.log("main")
                } else {
                    this.bCheckedSCCode1 = false;
                    this.bAllowSC = false;
                    console.log("sub")
                }
                break;
            case 2:
                this.bDisAllowSubTypes = true;
                this.fnToggleAndCheck(2);
                this.schoolType = 2;
                if (this.radioOptionsSchoolType['1'].checked == true) {
                    this.bAllowSC = true;
                    this.bCheckedSCCode2 = true;
                    this.schoolType = 2;
                    this.scValid = true;
                    this.radioOptionsSchoolType['0'].checked = false;
                   this.radioOptionsSchoolType['2'].checked = false;
                    this.iToggleSCValid1 = 0;
                    this.iToggleSCValid3 = 0;
                    this.bCheckedSCCode1 = false;
                    this.bCheckedSCCode3 = false;
                    //evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                } else {
                    this.bCheckedSCCode2 = false;
                    this.bAllowSC = false;
                }
                break;
            case 3:
                this.bAllowSC = false;
                this.fnToggleAndCheck(3);
                this.schoolType = 3;
                if (this.radioOptionsSchoolType['2'].checked == true) {
                    this.bCheckedSCCode3 = true;
                    this.schoolType = 3;
                    this.bDisAllowSubTypes = false;
                    this.scValid = true;
                    this.radioOptionsSchoolType['0'].checked = false;
                    this.radioOptionsSchoolType['1'].checked = false;
                    this.iToggleSCValid1 = 0;
                    this.iToggleSCValid2 = 0;
                    this.bCheckedSCCode1 = false;
                    this.bCheckedSCCode2 = false;
                   // evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                } else {
                    this.bCheckedSCCode3 = false;
                    this.bDisAllowSubTypes = true;

                }
                break;
        }

       return bRet;
    }

    fnFigureRadioSchoolStatusChecked(evt: Event, opId: number): boolean {
        this.schoolStatus = opId;
        //console.log("fnFigureRadioSchoolStatusChecked setting radio to:")
        //console.log(opId);
        return true;
    }

    fnToggleAndCheck(
        btnNum: number // toggles the radio button to second state and back
    ) {
     
        /*this.radioOptionsSchoolType['0'].checked = false; 
        this.radioOptionsSchoolType['1'].checked = false; 
        this.radioOptionsSchoolType['2'].checked = false; */
        // radio buttons for school type are: 1, 2, 3, but their radioOptionsSchoolType tags are 1 less, i.e. 0, 1, 2
        switch (btnNum) {
            case 1:
                this.iToggleSCValid1 = this.iToggleSCValid1 + 1;
                if (this.iToggleSCValid1 > 1) {
                    this.radioOptionsSchoolType['0'].checked = !this.radioOptionsSchoolType['0'].checked;
                    this.iToggleSCValid1 = 0;
                    console.log("this is a valid1")
                } else {
                    this.radioOptionsSchoolType['0'].checked = true;
                    console.log("this is not a valid1")
                }
                break;

            case 2:
                this.iToggleSCValid2 = this.iToggleSCValid2 + 1;
                if (this.iToggleSCValid2 > 1) {
                    this.radioOptionsSchoolType['1'].checked = !this.radioOptionsSchoolType['1'].checked;
                    this.iToggleSCValid2 = 0;
                    console.log("this is a valid2:" + this.iToggleSCValid2)
                } else {
                    this.radioOptionsSchoolType['1'].checked = true;
                }
                break;
            case 3:
                this.iToggleSCValid3 = this.iToggleSCValid3 + 1;
                if (this.iToggleSCValid3 > 1) {
                    this.radioOptionsSchoolType['2'].checked = !this.radioOptionsSchoolType['2'].checked;
                    this.iToggleSCValid3 = 0;
                    console.log("this is a valid3")
                } else {
                    this.radioOptionsSchoolType['2'].checked = true;
                }
                break;
        }
    }

    valueChkChange($event: any) {
        this.satelliteCampus = $event.checked;
    }

    openDialog() {
        console.log('sending this date to custom cal:' + this.closedDate);
        const dialogRef = this.dialog.open(CustomDatepickerComponent, {
            panelClass: 'custom-dialog-container',
            width: '24%',
            height: '50%',
            data: { selectedDate: this.closedDate }
        });
        dialogRef.afterClosed().subscribe((result) => {
            console.log('now resetting selected calendar date');
            console.log('result incoming:');
            console.log(result);
            if (result?.myResult) {
                this.closedDate = result.myResult;
            }
            if (result?.event) {
                if (result?.event == 'clear') {
                    this.closedDate = '';
                }
            }
            this.ngOnInit();
        });
    }

    validatedEmailEvent(event: any) {
        // console.log("validatedEmailEvent method called in create-school with:");
        // console.log(event);

        this.strCustomSchoolCodeError = '';
        this.bCustomSchoolCodeError = false;
    }
}
